import {
  UPDATE_SEARCH_TEXT,
  ON_SHOW_LOADING_STATE,
  ON_MY_EVENTS_STATUS_FILTER_CHANGE
} from '../actions.js';

const initialState = {
  searchText: '',
  showLoadingState: false
};

export default (state = initialState, action) => {
  if (action.type === UPDATE_SEARCH_TEXT) {
    return { searchText: action.payload, showLoadingState: false };
  }

  if (action.type === ON_SHOW_LOADING_STATE) {
    return { ...state, showLoadingState: true };
  }

  if (action.type === ON_MY_EVENTS_STATUS_FILTER_CHANGE) {
    return initialState;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/my-events/reducers/search.js